// App.js with simple routing
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Ontario2 from './pages/Ontario2.tsx';
import DonatePage from './pages/DonatePage.tsx';
import SurveyPage from './pages/SurveyPage.tsx';
import StayInTouchThankYouPage from './pages/StayInTouchThankYouPage.tsx';
import OptOutConfirmationPage from './pages/OptOutConfirmationPage.tsx';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Ontario2 />} />
          <Route path="/ontario2" element={<Ontario2 />} />
          <Route path="/donate" element={<DonatePage />} />
          <Route path="/survey" element={<SurveyPage />} />
          <Route path="/thank-you" element={<StayInTouchThankYouPage />} />
          <Route path="/unsubscribe-confirmed" element={<OptOutConfirmationPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
